<div class="title" style="position: relative;">
  <!-- Optional title in header -->
  <span *ngIf="data.showTitleInHeader">{{ data.title }}</span>
  <i class="fal fa-times-circle cancelX" mat-button cdkFocusInitial [mat-dialog-close]="false"></i>
</div>

<div class="dialog-content">
  <div *ngIf="!data.title">{{ "Are you sure you want to delete this item?" | i18next:{item:data.component} }}</div>
  <!-- keep old behavior -->
  <div *ngIf="data.title && !data.showTitleInHeader">{{ data.title }}</div>
  <div *ngIf="data.additionalText" class="additional-text">{{ data.additionalText }}</div>
  <div *ngIf="data.additionalSecondText" class="additional-text">{{ data.additionalSecondText }}</div>
</div>

<mat-dialog-actions style="justify-content: center;">
    <button *ngIf="!data.confirmText" matButton [mat-dialog-close]="true" class="primary-button">{{ 'Delete' | i18next }}</button>
    <button *ngIf="data.confirmText" matButton [mat-dialog-close]="true" class="primary-button">{{data.confirmText}}</button>
    <button *ngIf="!data.cancelText" matButton [mat-dialog-close]="false" class="secondary-button">{{ 'Cancel' | i18next }}</button>
    <button *ngIf="data.cancelText" matButton [mat-dialog-close]="false" class="secondary-button">{{ data.cancelText }}</button>
</mat-dialog-actions>
